import Vue from "vue";
import VueRouter from "vue-router";
import ordenesDeServicioRoutes from "../modules/ordenes-de-servicio/routes";
import liquidacionesRoutes from "../modules/liquidaciones/routes";
import privadosRoutes from "../modules/privados/routes";
import store from "../store";
import authRoutes from "../modules/auth/routes";
import endosadosRoutes from "../modules/endosados/routes";
import biblia_routes from "../modules/biblia/routes/biblia_routes";
import reportes_routes from "../modules/reportes/routes";
import comprobanteRoutes from "../modules/comprobantes/routes/comprobanteRoutes";

Vue.use(VueRouter);

const routes = [
  // auth
  ...authRoutes,
  {
    path: "",
    component: () => import(/* webpackChunkName: "app-layout" */ "@/modules/shared/layouts/AppLayout.vue"),
    children: [
      {
        path: "",
        name: "inicio",
        component: () => import(/* webpackChunkName: "inicio" */ "../views/Inicio.vue"),
      },
      {
        path: "/pruebas",
        name: "pruebas",
        component: () => import(/* webpackChunkName: "pruebas" */ "../views/pruebas.vue"),
      },
      ...biblia_routes,
      ...endosadosRoutes,
      {
        path: "/programacion",
        name: "programacion",
        component: () => import(/* webpackChunkName: "itinerario.privados" */ "../views/itinerario/privados.vue"),
      },
      {
        path: "/programacion/guias",
        name: "programacion.guias",
        component: () => import(/* webpackChunkName: "programacion.guias" */ "../views/programacion/guias/index.vue"),
      },
      {
        path: "/mantenimiento",
        component: () => import(/* webpackChunkName: "mantenimiento" */ "../views/mantenimiento/layout.vue"),
        children: [
          {
            path: "sedes",
            name: "mantenimiento.sedes",
            component: () => import(/* webpackChunkName: "mantenimiento.sedes" */ "../views/mantenimiento/sedes/index.vue"),
          },
          {
            path: "areas",
            name: "mantenimiento.areas",
            component: () => import(/* webpackChunkName: "mantenimiento.areas" */ "../views/mantenimiento/areas/index.vue"),
          },
          {
            path: "idiomas",
            name: "mantenimiento.idiomas",
            component: () => import(/* webpackChunkName: "mantenimiento.idiomas" */ "../views/mantenimiento/idiomas/index.vue"),
          },
          {
            path: "servicios",
            name: "mantenimiento.servicios",
            component: () => import(/* webpackChunkName: "mantenimiento.servicios" */ "../views/mantenimiento/servicios/index.vue"),
          },
          {
            path: "agencias",
            name: "mantenimiento.agencias",
            component: () => import(/* webpackChunkName: "mantenimiento.agencias" */ "../views/mantenimiento/agencias/index.vue"),
          },
          {
            path: "hoteles",
            name: "mantenimiento.hoteles",
            component: () => import(/* webpackChunkName: "mantenimiento.hoteles" */ "../views/mantenimiento/hoteles/index.vue"),
          },
          {
            path: "restaurantes",
            name: "mantenimiento.restaurantes",
            component: () => import(/* webpackChunkName: "mantenimiento.restaurantes" */ "../views/mantenimiento/restaurantes/index.vue"),
          },
          {
            path: "vehiculos",
            name: "mantenimiento.vehiculos",
            component: () => import(/* webpackChunkName: "mantenimiento.vehiculos" */ "../views/mantenimiento/vehiculos/index.vue"),
          },
          {
            path: "proveedores",
            name: "mantenimiento.proveedores",
            component: () => import(/* webpackChunkName: "mantenimiento.proveedores" */ "../views/mantenimiento/proveedores/index.vue"),
          },
          {
            path: "puntostrf",
            name: "mantenimiento.puntostrf",
            component: () => import(/* webpackChunkName: "mantenimiento.puntostrf" */ "../views/mantenimiento/puntostrf/index.vue"),
          },
          {
            path: "trenes",
            name: "mantenimiento.trenes",
            component: () => import(/* webpackChunkName: "mantenimiento.trenes" */ "../views/mantenimiento/trenes/index.vue"),
          },
          {
            path: "estaciones",
            name: "mantenimiento.estaciones",
            component: () => import(/* webpackChunkName: "mantenimiento.estaciones" */ "../views/mantenimiento/estaciones/index.vue"),
          },
          {
            path: "usuarios",
            name: "mantenimiento.usuarios",
            component: () => import(/* webpackChunkName: "mantenimiento-usuarios" */ "../views/mantenimiento/usuarios/index.vue"),
          },
          {
            path: "usuarios/nuevo",
            name: "mantenimiento.usuario.nuevo",
            component: () => import(/* webpackChunkName: "mantenimiento-usuario" */ "../views/mantenimiento/usuarios/save.vue"),
          },
          {
            path: "usuarios/:uuid",
            name: "mantenimiento.usuario",
            component: () => import(/* webpackChunkName: "mantenimiento-usuario" */ "../views/mantenimiento/usuarios/save.vue"),
          },
          {
            path: "generales",
            name: "mantenimiento.generales",
            component: () => import(/* webpackChunkName: "mantenimiento-generales" */ "../views/mantenimiento/generales/index.vue"),
          },
        ],
      },
      {
        path: "/reportes",
        name: "reportes",
        component: () => import(/* webpackChunkName: "reportes" */ "../views/reportes/index.vue"),
      },
      {
        path: "/reportes/guias",
        name: "reportes.guias",
        component: () => import(/* webpackChunkName: "reportes.guias" */ "../views/reportes/guias.vue"),
      },
      // reportes
      ...reportes_routes,

      // ordenes
      ...ordenesDeServicioRoutes,

      // privados
      ...privadosRoutes,

      // liquidaciones
      ...liquidacionesRoutes,

      // facturacion
      ...comprobanteRoutes,

      {
        path: "/error/403",
        name: "error.403",
        component: () => import(/* webpackChunkName: "error-404" */ "../views/errors/403.vue"),
      },
    ],
    beforeEnter(to, from, next) {
      if (to.query?.redirectedBy == "login") {
        store.commit("layout/updateLoading", false);
      }

      const isLogged = store.getters["auth/isLogged"];

      if (isLogged) {
        next();
      } else {
        next({ name: "auth.login" });
      }
    },
  },
  {
    path: "*",
    name: "error.404",
    component: () => import(/* webpackChunkName: "error-404" */ "../views/errors/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // const user = store.state.user;

  // if (user) {
  //   if (to.name == "auth.login") {
  //     return next({ name: "inicio" });
  //   }
  // } else {
  //   if (to.name == "auth.login") {
  //     return next();
  //   } else {
  //     return next({ name: "auth.login" });
  //   }
  // }

  // return next();

  return next();
});

export default router;
